import { ajaxFunc } from '../tools';

const live = {
  // 生活直播协议，提交用户签名
  liveAgreeProtocol: ajaxFunc('/member/live/agreeProtocol', 'post', 0 ,{
    'Content-Type':'application/json'
  }),
    // 生活直播协议，发送短信
    liveSendSmsCode: ajaxFunc('/member/live/sendSmsCode', 'post')
};

  
export default live;



// WEBPACK FOOTER //
// ./src/request/api/zhibo.js